import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import ImgContainer from './components/ImgContainer/ImgContainer';
import LayoutCenter from './components/LayoutCenter/LayoutCenter';
import NotFound from './components/NotFound/NotFound';
import { fetchIndustries, fetchTypeSeries } from './api/services';
import './App.less';
import { IntlProvider } from 'react-intl';
import { messages } from './locales'; // 导入包含翻译信息的文件
import { lang } from './api/config';

export default function App() {
  // 初始化状态
  const [state, setState] = useState({
    industries: [], // 行业列表
    typeSeries: [], // 类型系列列表
    selectedIndustry: null, // 当前选中的行业
    openType: null, // 当前打开的类型
    selectedSeries: null, // 当前选中的系列
    loading: true, // 加载状态
    keyword: '', // 搜索关键字
    flag: false, // 标志位
  });

  // 解构状态
  const {
    industries,
    typeSeries,
    selectedIndustry,
    openType,
    selectedSeries,
    loading,
    keyword,
    flag,
  } = state;

  // 加载行业列表
  useEffect(() => {
    fetchIndustries().then(data => {
      // 使用映射表确保行业列表的顺序
      const industryMap = {
        EnterpriseNetwork: 0,
        IndustrialDigitalization: 1,
        DigitalEnergy: 2,
        SmartCommerce: 3,
        Mobility: 4,
        CloudServices: 5,
      };
      const res = [];
      data.result.forEach(item => {
        if (industryMap[item.id] !== undefined) {
          res[industryMap[item.id]] = item;
        } else {
          res.push(item);
        }
      });
      setState(prevState => ({ ...prevState, industries: res }));
    });
  }, []);

  // 加载类型系列列表
  useEffect(() => {
    if (industries.length === 0 || !selectedIndustry) return;
    fetchTypeSeries(selectedIndustry).then(data => {
      const res = data.result.product_categories.filter(
        item => item.product_series && item.product_series.length > 0
      );
      // console.log(res, 'fetchTypeSeries');
      setState(prevState => ({
        ...prevState,
        typeSeries: res,
        loading: false,
      }));
    });
  }, [industries, selectedIndustry]);

  // 生成路由
  const generateRoutes = () => {
    let routes = [];
    if (typeSeries.length > 0) {
      typeSeries.forEach(type => {
        type.product_series.forEach(series => {
          routes.push(
            <Route
              key={`${type.id}/${series.id}`}
              path={`${type.id}/${series.id}`}
              element={<Navigate to={`${type.id}/${series.id}`} />}
            />
          );
        });
      });
    }
    // console.log(routes, 'routes');
    return routes;
  };

  // 监听 hash 变化并处理路由
  useEffect(() => {
    const currentHashname = window.location.hash;
    const pathParts = currentHashname.split('/');
    const currentModel = pathParts[1] || 'EnterpriseNetwork'; // 默认行业为 EnterpriseNetwork
    const typeId = pathParts[2];
    const seriesId = pathParts[3];
    // console.log(pathParts, 'pathParts');
    // console.log(currentModel, 'currentModel');
    // console.log(typeSeries, 'typeSeries');
    if (!typeId && typeSeries.length > 0) {
      const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
      window.location.href = pathname;
    } else if (typeId) {
      const typeExists = typeSeries.some(type => type.id === typeId);
      if (!typeExists && typeSeries.length > 0) {
        const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
        window.location.href = pathname;
      } else {
        setState(prevState => ({
          ...prevState,
          selectedIndustry: currentModel,
          openType: typeId,
          selectedSeries: seriesId,
        }));
      }
    } else if (currentModel === 'EnterpriseNetwork') {
      setState(prevState => ({ ...prevState, selectedIndustry: currentModel }));
    }
  }, [typeSeries]);

  return (
    <IntlProvider
      locale={lang}
      messages={messages[lang]}
    >
      <HashRouter>
        <div className='myFont'>
          {/* 渲染 ImgContainer 组件 */}
          <ImgContainer
            keyword={keyword}
            onChangeKeyword={v =>
              setState(prevState => ({ ...prevState, keyword: v }))
            }
            onChangeFlag={v =>
              setState(prevState => ({ ...prevState, flag: v }))
            }
            onChangeSelectedIndustry={v =>
              setState(prevState => ({ ...prevState, selectedIndustry: v }))
            }
          />
        </div>
        <Routes>
          {/* 渲染 LayoutCenter 组件 */}
          <Route
            path='/'
            element={
              <LayoutCenter
                flag={flag}
                keyword={keyword}
                onChangeFlag={v =>
                  setState(prevState => ({ ...prevState, flag: v }))
                }
                selectedIndustry={selectedIndustry}
                onChangeSelectedIndustry={v =>
                  setState(prevState => ({ ...prevState, selectedIndustry: v }))
                }
                typeSeries={typeSeries}
                onChangeTypeSeries={v =>
                  setState(prevState => ({ ...prevState, typeSeries: v }))
                }
                industries={industries}
                selectedSeries={selectedSeries}
                onchangeSelectedSeries={v =>
                  setState(prevState => ({ ...prevState, selectedSeries: v }))
                }
                openType={openType}
                onchangeOpenType={v =>
                  setState(prevState => ({ ...prevState, openType: v }))
                }
                loading={loading}
                onChangeLoading={v =>
                  setState(prevState => ({ ...prevState, loading: v }))
                }
                handleRouter={generateRoutes}
              />
            }
          >
            {/* 渲染行业对应的路由 */}
            {industries.map(industry => (
              <Route
                key={industry.id}
                path={industry.id}
                element={<Navigate to={industry.id} />}
              >
                {/* 渲染类型系列对应的路由 */}
                {typeSeries.length > 0 && generateRoutes()}
              </Route>
            ))}
          </Route>
          {/* 渲染 404 页面 */}
          {typeSeries.length > 0 && (
            <Route
              path='*'
              element={<NotFound />}
            />
          )}
        </Routes>
      </HashRouter>
    </IntlProvider>
  );
}
